/**
 * Connection status bar for WebSocket connectivity indication.
 */
import type { ReactNode } from 'react'

import { ChatConnectionStatus } from '@/components/chat/chat-connection-status.atom'
import type { WebSocketState } from './chat.view.hook'

interface ConnectionStatusBarProps {
  websocketState: WebSocketState
}

export const ConnectionStatusBar = ({ websocketState }: ConnectionStatusBarProps): ReactNode => {
  if (websocketState.connectionStatus !== 'disconnected') return null
  return (
    <div className="connection-status-bar flex justify-center border-t bg-muted/50 px-4 py-2">
      <ChatConnectionStatus
        status={websocketState.connectionStatus}
        onReconnect={websocketState.onReconnect}
      />
    </div>
  )
}
